import Dashboard from '@/components/pages/Dashboard.vue';
import Animate from '@/components/pages/examples/animations/Animate.vue';
import Login from '@/components/pages/Login.vue';
import Lock from '@/components/pages/Lock.vue';

import FormElements from '@/components/pages/examples/form/FormElements.vue';
import General from '@/components/pages/examples/form/General.vue';
import Advanced from '@/components/pages/examples/form/Advanced.vue';

import Widgets from '@/components/pages/examples/widget/Widgets.vue';
import Galleries from '@/components/pages/examples/galleries/Galleries.vue';
// import FileUploadsPage from '@/components/pages/examples/uploads/FileUploads.vue';

// Misc
import Misc from '@/components/pages/examples/misc/Misc.vue';
import Notifications from '@/components/pages/examples/misc/Notifications.vue';
import Spinner from '@/components/pages/examples/misc/Spinner.vue';
import List from '@/components/pages/examples/misc/List.vue';
import Maps from '@/components/pages/examples/misc/Maps.vue';
import Poll from '@/components/pages/examples/poll/Poll.vue';

import Buttons from '@/components/pages/examples/buttons/Buttons.vue';

import AppViews from '@/components/pages/examples/app_views/AppViews.vue';
import Contacts from '@/components/pages/examples/app_views/Contacts.vue';
import Article from '@/components/pages/examples/app_views/Article.vue';
import Blog from '@/components/pages/examples/app_views/Blog.vue';
import Profile from '@/components/pages/examples/app_views/Profile.vue';
// import FileUploads from '@/components/pages/examples/app_views/FileUploads'
import Calendar from '@/components/pages/examples/app_views/Calendar.vue';
import Errors from '@/components/pages/examples/app_views/Errors.vue';
import ContactUs from '@/components/pages/examples/app_views/ContactUs.vue';
import Pricing from '@/components/pages/examples/app_views/Pricing.vue';
import FAQ from '@/components/pages/examples/app_views/FAQ.vue';

// Charts
import ChartComponents from '@/components/pages/examples/chart_components/ChartComponents.vue';
import VueCharts from '@/components/pages/examples/chart_components/vuecharts/VueCharts.vue';
import ChartjsComponents from '@/components/pages/examples/chart_components/vuechartjs/ChartjsComponents.vue';
// import ChartistComponents from '@/components/pages/examples/chart_components/ChartistComponents'
import ChartkickComponents from '@/components/pages/examples/chart_components/ChartkickComponents.vue';
import HighchartsComponents from '@/components/pages/examples/chart_components/HighchartsComponents.vue';

// Ui Elements
import Elements from '@/components/pages/examples/uielements/Elements.vue';
import Typography from '@/components/pages/examples/uielements/Typography.vue';
import Helpers from '@/components/pages/examples/uielements/Helpers.vue';


// Tables
import Tables from '@/components/pages/examples/tables/Tables.vue';
import BuefyTables from '@/components/pages/examples/tables/BuefyTables.vue';
import VueGoodTable from '@/components/pages/examples/tables/VueGoodTable.vue';
import HandsonTable from '@/components/pages/examples/tables/HandsonTable.vue';

// Grids
import Grids from '@/components/pages/examples/grids/Grids.vue';

export default [
  // Dashbaord
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      breadcrumb: 'Dashboard',
      title: 'Dashboard',
      subtitle: 'Version 1.0',
    },
  },

  // Grids
  {
    path: '/grids',
    name: 'grids',
    component: Grids,
    meta: {
      breadcrumb: 'Grids',
      title: 'Grids',
      subtitle: '',
    },
  },

  // Login
  {
    path: '/login',
    name: 'login',
    component: Login,
  },

  // Lock
  {
    path: '/lock',
    name: 'lock',
    component: Lock,
  },

  // UI Elements
  {
    path: '/ui-elements',
    name: 'ui-elements',
    component: Elements,
    children: [
      // Typography
      {
        path: 'typography',
        name: 'typography',
        component: Typography,
        meta: {
          breadcrumb: 'Typography',
          title: 'Typography',
          subtitle: '',
        },
      },
      // Helpers
      {
        path: 'helpers',
        name: 'helpers',
        component: Helpers,
        meta: {
          breadcrumb: 'Helpers',
          title: 'Helpers',
          subtitle: 'CSS classes',
        },
      },
    ],
  },

  // Buttons
  {
    path: '/buttons',
    name: 'buttons',
    component: Buttons,
    meta: {
      breadcrumb: 'Buttons',
      title: 'Buttons',
      subtitle: '',
    },
  },

  // Galleries
  {
    path: '/galleries',
    name: 'galleries',
    component: Galleries,
    meta: {
      breadcrumb: 'Galleries',
      title: 'Galleries',
      subtitle: '',
    },
  },

  // File uploads
  // {
  //   path: '/file-page-uploads',
  //   name: 'file-page-uploads',
  //   component: FileUploadsPage,
  //   meta: {
  //     breadcrumb: 'File Uploads',
  //     title: 'File Uploads',
  //     subtitle: '',
  //   },
  // },

  // Annimations
  {
    path: '/animations',
    name: 'animations',
    component: Animate,
    meta: {
      breadcrumb: 'Animations',
      title: 'Animations',
      subtitle: '',
    },
  },

  // Form Elements
  {
    path: '/form-elements',
    name: 'form-elements',
    component: FormElements,
    children: [
      {
        path: 'generals',
        name: 'generals',
        component: General,
        meta: {
          breadcrumb: 'General',
          title: 'Form Elements',
          subtitle: 'General',
        },
      },
      {
        path: 'advanced',
        name: 'advanced',
        component: Advanced,
        meta: {
          breadcrumb: 'Advanced',
          title: 'Form Elements',
          subtitle: 'Advanced',
        },
      },
    ],
  },

  // Poll
  {
    path: '/poll',
    name: 'poll',
    component: Poll,
    meta: {
      breadcrumb: 'Poll',
      title: 'Poll',
      subtitle: '',
    },
  },

  // Misc
  {
    path: '/misc',
    name: 'misc',
    component: Misc,
    children: [
      {
        path: 'notifications',
        name: 'notifications',
        component: Notifications,
        meta: {
          breadcrumb: 'Notifications',
          title: 'Notifications',
          subtitle: '',
        },
      },
      {
        path: 'spinner',
        name: 'spinner',
        component: Spinner,
        meta: {
          breadcrumb: 'Spinner',
          title: 'Spinner',
          subtitle: '',
        },
      },
      {
        path: 'list',
        name: 'list',
        component: List,
        meta: {
          breadcrumb: 'List',
          title: 'List',
          subtitle: '',
        },
      },
      {
        path: '/maps',
        name: 'maps',
        component: Maps,
        meta: {
          breadcrumb: 'Maps',
          title: 'Maps',
          subtitle: '',
        },
      },
    ],
  },

  // Widgets
  {
    path: '/widgets',
    name: 'widgets',
    component: Widgets,
    meta: {
      breadcrumb: 'Widgets',
      title: 'Widgets',
      subtitle: '',
    },
  },

  // App Views
  {
    path: '/app-views',
    name: 'app-views',
    component: AppViews,
    children: [
      {
        path: 'contacts',
        name: 'contacts',
        component: Contacts,
        meta: {
          breadcrumb: 'Contacts',
          title: 'Contacts',
          subtitle: '',
        },
      },
      {
        path: 'article',
        name: 'article',
        component: Article,
        meta: {
          breadcrumb: 'Article',
          title: 'Article',
          subtitle: '',
        },
      },
      {
        path: 'blog',
        name: 'blog',
        component: Blog,
        meta: {
          breadcrumb: 'Blog',
          title: 'Blog',
          subtitle: '',
        },
      },
      {
        path: 'profile',
        name: 'profile',
        component: Profile,
        meta: {
          breadcrumb: 'Profile',
          title: 'Profile',
          subtitle: '',
        },
      },
      // { path: 'file-uploads', name: 'file-uploads', component: FileUploads },
      {
        path: 'calendar',
        name: 'calendar',
        component: Calendar,
        meta: {
          breadcrumb: 'Calendar',
          title: 'Calendar',
          subtitle: '',
        },
      },
      {
        path: 'errors',
        name: 'errors',
        component: Errors,
        meta: {
          breadcrumb: 'Errors',
          title: 'Errors',
          subtitle: '',
        },
      },
      {
        path: 'contact-us',
        name: 'contact-us',
        component: ContactUs,
        meta: {
          breadcrumb: 'Contact Us',
          title: 'Contact Us',
          subtitle: '',
        },
      },
      {
        path: 'pricing',
        name: 'pricing',
        component: Pricing,
        meta: {
          breadcrumb: 'Pricing',
          title: 'Pricing',
          subtitle: '',
        },
      },
      {
        path: 'faq',
        name: 'faq',
        component: FAQ,
        meta: {
          breadcrumb: 'FAQ',
          title: 'FAQ',
          subtitle: '',
        },
      },
    ],
  },

  // Charts
  {
    path: '/chart-components',
    name: 'chart-components',
    component: ChartComponents,
    children: [
      {
        path: 'chartjs',
        name: 'chartjs',
        component: ChartjsComponents,
        meta: {
          breadcrumb: 'ChartJS',
          title: 'Chart Components',
          subtitle: 'ChartJS',
        },
      },
      {
        path: 'vuecharts',
        name: 'vuecharts',
        component: VueCharts,
        meta: {
          breadcrumb: 'VueCharts',
          title: 'Chart Components',
          subtitle: 'VueCharts',
        },
      },
      {
        path: 'chartkick',
        name: 'chartkick',
        component: ChartkickComponents,
        meta: {
          breadcrumb: 'Chart Kick',
          title: 'Chart Components',
          subtitle: 'Chart Kick',
        },
      },
      {
        path: 'highcharts',
        name: 'highcharts',
        component: HighchartsComponents,
        meta: {
          breadcrumb: 'High Charts',
          title: 'Chart Components',
          subtitle: 'High Charts',
        },
      },
    ],
  },

  // Tables
  {
    path: '/tables',
    name: 'tables',
    component: Tables,
    children: [
      {
        path: 'handson-tables',
        name: 'handson-tables',
        component: HandsonTable,
        meta: {
          breadcrumb: 'HandsonTable',
          title: 'Tables',
          subtitle: 'HandsonTable',
        },
      },
      {
        path: 'buefy-tables',
        name: 'buefy-tables',
        component: BuefyTables,
        meta: {
          breadcrumb: 'Buefy Tables',
          title: 'Tables',
          subtitle: 'Buefy Tables',
        },
      },
      {
        path: 'vue-good-tables',
        name: 'vue-good-tables',
        component: VueGoodTable,
        meta: {
          breadcrumb: 'Vue Good Tables',
          title: 'Tables',
          subtitle: 'Vue Good Tables',
        },
      },
    ],
  },
];
